/*
 *   Copyright (c) 2022 Busy Human LLC
 *   All rights reserved.
 *   This file, its contents, concepts, methods, behavior, and operation  (collectively the "Software") are protected by trade secret, patent,  and copyright laws. The use of the Software is governed by a license  agreement. Disclosure of the Software to third parties, in any form,  in whole or in part, is expressly prohibited except as authorized by the license agreement.
 */
import { httpsCallable } from 'firebase/functions';
import { functions } from '@/util/firebase';
import { FunctionTypes } from "@busy-human/opt-library";

import fnTypes = FunctionTypes.OnboardPaymentAccount;

const onboardPaymentAccount = httpsCallable<fnTypes.OnboardPaymentAccountData, fnTypes.OnboardPaymentAccountReturn>(functions, 'onboardPaymentAccount');

export async function getLink( userId: string ) {
    const result = await onboardPaymentAccount({
        uid: userId
    });
    if(result.data.status === "enabled") {
        console.log(`Account setup complete already`);
        return result;
    } else if (result.data.redirectUrl) {
        console.log(`Redirecting to account setup ${result.data.redirectUrl}`);
        window.location.href = result.data.redirectUrl;
        return result;
    } else {
        console.log("RESULT", result);
        alert(`Something went wrong`);
    }
}
